import type * as React from 'react';
import DatePicker from '@cloudscape-design/components/date-picker';
import FormField from '@cloudscape-design/components/form-field';
import type { PropertyFilterProps } from '@cloudscape-design/components/property-filter';

/**
 * Form de data dos tokens `>=`/`<=` (createdAt / statusChangedAt) do
 * PropertyFilter da lista de Empresas. Emite `YYYY-MM-DD`, que a callable
 * `searchTenants` parseia como início/fim do dia.
 */
export function TenantDateForm({
  value,
  onChange,
}: PropertyFilterProps.ExtendedOperatorFormProps<string>): React.JSX.Element {
  return (
    <FormField>
      <DatePicker
        value={value ?? ''}
        onChange={({ detail }): void => {
          onChange(detail.value);
        }}
        placeholder="YYYY/MM/DD"
        openCalendarAriaLabel={(selected): string =>
          selected ? `Selecionar data, ${selected}` : 'Selecionar data'
        }
      />
    </FormField>
  );
}
